// Rendered card markup must mirror partials/food-feature-card.hbs and food-review-card.hbs.
(function () {
    const root = document.querySelector('.food-tag');
    if (!root) return;

    // Palette + hash duplicated from food-map.js — keep in sync so colours match the map.
    const CUISINE_PALETTE = [
        '#4e6498', // bleu outremer 31 · 32020
        '#366c8e', // bleu céruléen 31 · 32030
        '#7fb4b5', // céruléen moyen · 32032
        '#2c695a', // vert anglais · 32040
        '#39774f', // vert foncé · 32050
        '#87b26c', // vert 31 · 32051
        '#de6433', // orange · 32080
        '#e88e5a', // orange clair · 32081
        '#9c2128', // rouge vermillon 31 · 32090
        '#811c35', // rouge carmin · 32100
        '#e3b09b', // rose clair · 32102
        '#884333', // l'ocre rouge · 32110
        '#d28b7a', // l'ocre rouge moyen · 32111
        '#a86a5d', // terre sienne brique · 32121
        '#e8c29e', // terre sienne claire 31 · 32122
        '#a33a29', // rouge vermillon 59 · 4320A
        '#de8da0', // rose vif · 4320C
        '#a4aa35', // vert olive vif · 4320F
        '#559778', // vert 59 · 4320G
        '#f2b573', // ocre jaune clair · 4320L
        '#6c2b3b', // le rubis · 4320M
        '#7facc6', // bleu céruléen 59 · 4320N
        '#f7cc9d', // terre sienne claire 59 · 4320P
        '#d15c32', // orange vif · 4320S
        '#f4bd48', // le jaune vif · 4320W
    ];
    const CUISINE_OVERRIDES = {
        'hash-cuisine-american': '#366c8e',
        'hash-cuisine-german': '#de6433',
        'hash-cuisine-pizza': '#a4aa35',
        'hash-cuisine-vegan': '#a1c977',
    };
    function colorFromSlug(slug) {
        if (!slug) return null;
        if (CUISINE_OVERRIDES[slug]) return CUISINE_OVERRIDES[slug];
        // Hash the prefix-stripped name so the same name always maps to the same swatch.
        const key = slug.replace(/^hash-(cuisine|area)-/, '');
        let hash = 0;
        for (let i = 0; i < key.length; i++) {
            hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
        }
        return CUISINE_PALETTE[hash % CUISINE_PALETTE.length];
    }

    function formatReviewMeta(scope) {
        scope.querySelectorAll('.food-tag__review-card').forEach(function (card) {
            const cuisineEl = card.querySelector('[data-review-cuisine]');
            const neighborhoodEl = card.querySelector('[data-review-neighborhood]');
            if (!cuisineEl) return;
            // Load-more re-runs this over the whole container.
            if (cuisineEl.dataset.formatted === '1') return;
            const tags = (card.dataset.tags || '').trim().split(/\s+/);
            const cuisineSlug = tags.find(function (t) {
                return t.indexOf('hash-cuisine-') === 0;
            });
            const areaSlug = tags.find(function (t) {
                return t.indexOf('hash-area-') === 0;
            });
            if (cuisineSlug) {
                cuisineEl.textContent = labelFromSlug(cuisineSlug, 'hash-cuisine-');
                const color = colorFromSlug(cuisineSlug);
                if (color) card.style.setProperty('--cuisine-color', color);
            } else {
                cuisineEl.textContent = '';
            }
            if (neighborhoodEl) {
                if (areaSlug) {
                    neighborhoodEl.textContent = labelFromSlug(areaSlug, 'hash-area-');
                } else {
                    neighborhoodEl.textContent = '';
                }
            }
            cuisineEl.dataset.formatted = '1';
            fitMeta(card);
        });
    }
    function labelFromSlug(slug, prefix) {
        return slug
            .slice(prefix.length)
            .replace(/-/g, ' ')
            .replace(/\b\w/g, function (c) {
                return c.toUpperCase();
            });
    }

    // Shrink until both badges fit one line; em padding scales along, min floors readability.
    function fitMeta(card) {
        const meta = card.querySelector('.food-tag__review-meta');
        if (!meta) return;
        const max = 11;
        const min = 8;
        meta.style.fontSize = max + 'px';
        let size = max;
        while (meta.scrollWidth > meta.clientWidth + 1 && size > min) {
            size -= 0.5;
            meta.style.fontSize = size + 'px';
        }
    }

    // Re-fit on resize: card width changes as columns reflow.
    let resizeRaf = 0;
    window.addEventListener('resize', function () {
        if (resizeRaf) return;
        resizeRaf = requestAnimationFrame(function () {
            resizeRaf = 0;
            document.querySelectorAll('.food-tag__review-card').forEach(fitMeta);
        });
    });

    formatReviewMeta(document);

    const triggers = document.querySelectorAll('[data-load-more]');
    if (!triggers.length) return;

    const cfg = window.HEIST_FOOD_TAG;
    if (!cfg || !cfg.contentApiKey) {
        console.warn(
            '[food-tag] window.HEIST_FOOD_TAG.contentApiKey missing; load-more disabled. Ghost Admin → Design → Customise → Content api key.',
        );
        triggers.forEach(function (t) {
            t.setAttribute('hidden', '');
        });
        return;
    }

    // Filter + limit must match the SSR {{#get}} in food.hbs, or load-more queries a different post set.
    const feeds = {
        features: {
            filter: 'tag:food+tag:-hash-food-map',
            limit: 2,
            page: 1,
            container: document.querySelector('[data-feed="features"]'),
            render: renderFeatureCard,
        },
        reviews: {
            filter: 'tag:hash-food-map',
            limit: 12,
            page: 1,
            container: document.querySelector('[data-feed="reviews"]'),
            render: renderReviewCard,
        },
    };

    triggers.forEach(function (btn) {
        const key = btn.dataset.loadMore;
        const feed = feeds[key];
        if (!feed || !feed.container) {
            btn.setAttribute('hidden', '');
            return;
        }
        btn.addEventListener('click', function () {
            loadNextPage(feed, btn);
        });
    });

    function loadNextPage(feed, btn) {
        if (btn.dataset.loading === '1') return;
        btn.dataset.loading = '1';
        const originalLabel = btn.textContent;
        btn.textContent = 'Loading…';
        feed.page += 1;
        const url =
            cfg.apiUrl +
            '/posts/?' +
            [
                'key=' + encodeURIComponent(cfg.contentApiKey),
                'filter=' + encodeURIComponent(feed.filter),
                'include=' + encodeURIComponent('tags,authors'),
                'order=' + encodeURIComponent('published_at desc'),
                'limit=' + feed.limit,
                'page=' + feed.page,
                'fields=' +
                    encodeURIComponent(
                        'id,slug,url,title,excerpt,feature_image,published_at,primary_tag',
                    ),
            ].join('&');
        fetch(url, {headers: {Accept: 'application/json'}})
            .then(function (r) {
                if (!r.ok) throw new Error('HTTP ' + r.status);
                return r.json();
            })
            .then(function (data) {
                const posts = data.posts || [];
                const meta = data.meta && data.meta.pagination;
                posts.forEach(function (post) {
                    feed.container.insertAdjacentHTML('beforeend', feed.render(post));
                });
                if (!meta || feed.page >= meta.pages || posts.length < feed.limit) {
                    btn.setAttribute('hidden', '');
                } else {
                    btn.textContent = originalLabel;
                }
                if (feed === feeds.reviews) formatReviewMeta(feed.container);
            })
            .catch(function (err) {
                console.warn('[food-tag] load-more failed:', err);
                feed.page -= 1;
                btn.textContent = originalLabel;
            })
            .finally(function () {
                delete btn.dataset.loading;
            });
    }

    function renderFeatureCard(post) {
        const img = post.feature_image
            ? '<a class="food-tag__feature-image" href="' +
              escapeAttr(post.url) +
              '" aria-hidden="true" tabindex="-1"><img src="' +
              escapeAttr(post.feature_image) +
              '" alt="" loading="lazy" /></a>'
            : '<div class="food-tag__feature-image" data-empty></div>';
        const tagPills = (post.tags || [])
            .filter(function (t) {
                return t.visibility === 'public';
            })
            .map(function (t) {
                const styleAttr = t.accent_color
                    ? ' style="background-color: ' + escapeAttr(t.accent_color) + ';"'
                    : '';
                const primary =
                    post.primary_tag && post.primary_tag.slug === t.slug
                        ? ' post-card-primary-tag'
                        : '';
                const href = t.slug === 'news' ? '/news/' : t.url || '#';
                return (
                    '<a href="' +
                    escapeAttr(href) +
                    '" class="post-card-tag' +
                    primary +
                    '"' +
                    styleAttr +
                    '>' +
                    escapeHtml(t.name) +
                    '</a>'
                );
            })
            .join('');
        return (
            '<article class="food-tag__feature-card">' +
            img +
            '<div class="food-tag__feature-body">' +
            '<div class="post-card-tags">' +
            tagPills +
            '</div>' +
            '<h3 class="food-tag__feature-title"><a href="' +
            escapeAttr(post.url) +
            '">' +
            escapeHtml(post.title) +
            '</a></h3>' +
            '<p class="food-tag__feature-excerpt">' +
            escapeHtml(truncateWords(post.excerpt || '', 22)) +
            '</p>' +
            '<time class="food-tag__feature-date" datetime="' +
            isoDate(post.published_at) +
            '">' +
            formatDate(post.published_at) +
            '</time>' +
            '</div>' +
            '</article>'
        );
    }

    function renderReviewCard(post) {
        const img = post.feature_image
            ? '<a class="food-tag__review-image" href="' +
              escapeAttr(post.url) +
              '" aria-hidden="true" tabindex="-1"><img src="' +
              escapeAttr(post.feature_image) +
              '" alt="" loading="lazy" /></a>'
            : '<div class="food-tag__review-image" data-empty></div>';
        const tagSlugs = (post.tags || [])
            .map(function (t) {
                return t.slug;
            })
            .join(' ');
        return (
            '<article class="food-tag__review-card" data-tags="' +
            escapeAttr(tagSlugs) +
            '">' +
            img +
            '<div class="food-tag__review-body">' +
            '<p class="food-tag__review-meta">' +
            '<span class="food-tag__review-cuisine" data-review-cuisine>&nbsp;</span>' +
            '<span class="food-tag__review-neighborhood" data-review-neighborhood></span>' +
            '</p>' +
            '<h3 class="food-tag__review-title"><a href="' +
            escapeAttr(post.url) +
            '">' +
            escapeHtml(post.title) +
            '</a></h3>' +
            '<p class="food-tag__review-excerpt">' +
            escapeHtml(truncateWords(post.excerpt || '', 14)) +
            '</p>' +
            '</div>' +
            '</article>'
        );
    }

    function truncateWords(text, n) {
        const words = text.split(/\s+/);
        if (words.length <= n) return text;
        return words.slice(0, n).join(' ') + '…';
    }

    function isoDate(s) {
        return (s || '').slice(0, 10);
    }

    function formatDate(s) {
        if (!s) return '';
        const d = new Date(s);
        if (isNaN(d.getTime())) return '';
        return d.toLocaleDateString('en-US', {month: 'long', day: 'numeric', year: 'numeric'});
    }

    function escapeHtml(s) {
        return String(s).replace(/[&<>"]/g, function (c) {
            return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c];
        });
    }

    function escapeAttr(s) {
        return escapeHtml(s);
    }
})();
